import React from 'react';
import classNames from 'classnames';
import DOMPurify from 'dompurify';

const QaCard = ({
  id,
  questions = [],
  answers = [],
  tags = [],
  isActive = false,
  setActive = () => {},
  onClick = null
}) => {
  const classes = classNames({
    'qa-list-item': true,
    'qa-list-item-active': isActive,
    'qa-list-item-clickable': typeof onClick === 'function'
  });

  return (
    <div className={classes} onClick={onClick && onClick}>
      <div className="qa-list-item-id">{id}</div>
      <div
        className="qa-list-item-question"
        key={questions && questions[0] && questions[0].text}
      >
        {questions && questions[0] && questions[0].text}
      </div>
      <div
        className="qa-list-item-answer"
        dangerouslySetInnerHTML={{
          __html:
            answers &&
            DOMPurify.sanitize(answers[0].text, {
              ALLOWED_TAGS: [
                'br',
                'b',
                'a',
                'u',
                'i',
                'strong',
                'img',
                'button'
              ]
            })
        }}
      ></div>
      {tags && tags.length > 0 && (
        <div className="qa-list-item-tags">
          {tags.map(tag => (
            <div key={tag.id} className="qa-list-item-tag">
              {tag.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QaCard;
